import { ReactNode } from 'react';
import { ConvexProvider, ConvexReactClient } from 'convex/react';
import { AuthProvider } from '@/contexts/AuthContext';

// Use a placeholder URL if VITE_CONVEX_URL is not set
// This allows the app to run without Convex configured
const convexUrl = import.meta.env.VITE_CONVEX_URL || 'https://placeholder.convex.cloud';
const convex = new ConvexReactClient(convexUrl);

export function ConvexClientProvider({ children }: { children: ReactNode }) {
  return (
    <ConvexProvider client={convex}>
      <AuthProvider>
        {children}
      </AuthProvider>
    </ConvexProvider>
  );
}

